import { QueryClient } from '@tanstack/vue-query'
import { experimental_createQueryPersister } from '@tanstack/query-persist-client-core'

const persister = experimental_createQueryPersister({
    storage: localStorage,
    maxAge: 1000 * 60 * 60 * 12, // 12 hours
})

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 3,
            gcTime: 1000 * 60, // 1 Minute
            persister: persister.persisterFn,
        },
    },
})